import React from 'react'
import Layout from '../../../brands/components/Layout'
import { Formik } from 'formik'
import { InputField } from '../../../../components'
import SelectField from '../../../../components/Form/Select'
import TextAreaField from '../../../../components/Form/TextArea'
import './index.css'
import { MAX_CHAR_COUNT } from '../../../../utils/index'

const UploadItem: React.FC = () => {
    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Upload Item</h4>
                    </div>
                    <div className="upload-form">
                        <Formik
                            initialValues={{
                                email: '',
                                password: '123Pa$$word!',
                            }}
                            onSubmit={() => console.log('')}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <InputField
                                                type="text"
                                                lable={'Title'}
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="exampleSelect"
                                                label="Resource Type"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: '',
                                                    },
                                                    {
                                                        value: 'Australia',
                                                        label: 'Australia',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <SelectField
                                                name="exampleSelect"
                                                label="Link/File"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: '',
                                                    },
                                                    {
                                                        value: 'Australia',
                                                        label: 'Australia',
                                                    },
                                                ]}
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6">
                                            <TextAreaField
                                                name="exampleTextArea"
                                                label="Description"
                                                placeholder=""
                                                value={''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.password}
                                                touched={touched.password}
                                                defaultValue="Initial value"
                                                rows={6}
                                                maxLength={MAX_CHAR_COUNT}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="col-sm-6 button-block">
                                            <a className="button button-primary me-5">
                                                UPLOAD
                                            </a>
                                            <a className="button button-outline">
                                                CANCEL
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default UploadItem
